import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, getSettingValueSelector, screenSelector } from "@client/selectors";
import { type AppState, ScreenType } from "@client/types";
import { loadNextPage, showVoteModal } from "../actions";
import { localStateSelector } from "../selectors";
import { type Leaderboard } from "../types";
import Component, { type ActionProps, type MapProps } from "./component";
import { makeRewardsSelector, makeTopTitleSelector } from "./selectors";

const makeMapStateToProps = () => {
  const topTitleSelector = makeTopTitleSelector();
  const rewardsSelector = makeRewardsSelector();
  const entityTypeSelector = getSettingValueSelector(TargetSelector.Entity, "type");

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      current: localState.current,
      topTitle: topTitleSelector(state, props),
      hasMore: localState.hasMore,
      isEditMode: state.isEditMode,
      isLoading: localState.status === "LoadingPage",
      isMobile: screenSelector(state) === ScreenType.Mobile,
      referring: localState.referring,
      rewards: rewardsSelector(state, props),
      status: localState.status,
      type: entityTypeSelector(state, props),
      items: localState.items
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onLoadNextPage: () => dispatch(loadNextPage(getEntityRef(props))),
  onClickItem: (item: Leaderboard.Item) => dispatch(showVoteModal(getEntityRef(props), item.userId))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
